//# sourceMappingURL=option_.mjs.map
/// <reference types="./option_.d.mts" />
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";

/**
 * Takes an option, a fallback value and a single function. If the value of the
 * option is `Some`, calls the function with the value of the option and
 * returns the function's result. Otherwise the option is `None`, so it returns
 * the fallback value without running the function.
 *
 * Useful to replace the pattern `option.map(...) |> option.unwrap(...)` while
 * keeping the next function at top-level.
 *
 * ```gleam
 * option_.map_unwrap(Some(1), "NaN", fn(x) { int.to_string(x) })   // "1"
 * option_.map_unwrap(None, "NaN", fn(x) { int.to_string(x) }       // "NaN"
 * use x <- option_.map_unwrap(Some(1), "NaN")
 * int.to_string(x)                                                 // "1"
 * ```
 */
export function map_unwrap(value, fallback, next) {
  if (value instanceof Some) {
    let a = value[0];
    return next(a);
  } else {
    return fallback;
  }
}

export function map_lazy_unwrap(value, fallback, next) {
  if (value instanceof Some) {
    let a = value[0];
    return next(a);
  } else {
    return fallback();
  }
}
